import React, { useContext, useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { MsalContext } from "../../Contexts/MsalContext";
import MonitoringTitleBarViewModel from "../../Monitoring/ViewModels/MonitoringTitleBarViewModel";
import { formatDate } from "../../Utilities/UtilityMethods";

interface IProps {
    callRefId: string;
    close: () => void;
}

export default function FeedbackPageTitleBar(props: IProps) {
    const { msalFetch } = useContext(MsalContext);
    const [titleBarData, setTitleBarData] = useState<MonitoringTitleBarViewModel>(new MonitoringTitleBarViewModel())

    useEffect(() => {
        if (props.callRefId) {
            getData();
        }
    }, [props.callRefId])

    const getData = () => {
        msalFetch(`api/MonitoringCallInfo/GetTitleBar?systemPk=${props.callRefId}`)
            .then(response => response.json())
            .then(Data => {
                setTitleBarData(Data.value);
            });
    }

    return (
        <AppBar position="static" color="default" >
            <Toolbar variant="dense">
                <Button variant="outlined" onClick={props.close} sx={{ ml: -2, mr: 2 }}>Back</Button>
                <Typography variant="body1" component="div" sx={{ flexGrow: 1 }}>{titleBarData.client} - {titleBarData.agentName} - {formatDate(titleBarData.eventTime)} - {new Date(titleBarData.eventTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} - {titleBarData.result}</Typography>
            </Toolbar>
        </AppBar>
    );
}